import { useEffect, useState } from 'react'
import { useGetWellData } from '../../../../../../hooks/use-api'
import { AquiferTestFieldsView, AquiferTestObservationWellFieldsView } from '../../../../../../../types/form-types'
import AquiferTestDetailsViewForm from '../../../../../../components/well-forms/aquifer-test/aquifer-test-details-view'
import TestAnalysisViewForm from '../../../../../../components/well-forms/aquifer-test/test-analysis-view'
import AquiferTestQualityRatingFormEdit from '../../../../../../components/well-forms/aquifer-test/quality-rating-view'
import AquiferTestObservationWellsViewForm from '../../../../../../components/well-forms/aquifer-test/aquifer-test-observation-wells-view'
import WellViewButtons from '../../../../../../components/wells/well-view-buttons'
import AquiferTestResultsViewForm from '../../../../../../components/well-forms/aquifer-test/aquifer-test-results-view'
import NotesWrapperView from '../../../../../../components/well-forms/notes/notes-wrapper-view'
import { useParamsOr404 } from '../../../../../../hooks/use-params-or-404'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  ButtonsContainer,
  Divider,
  Heading,
  RecordContent,
  RecordFooter,
  useTitleChange,
} from '@msaf/core-react'

export default function AquiferTestView() {
  useTitleChange('Edit Well | Aquifer Test')

  const [fields, setFields] = useState<Partial<AquiferTestFieldsView>>({})
  const { id, aquiferTestId } = useParamsOr404('id', 'aquiferTestId')
  const navigate = useNavigate()
  const backUrl = `/wells/${id}/view/aquifer-tests`

  const url = `wells/${id}/aquifer-test/${aquiferTestId}/view`
  const { isLoading, isSuccess, data } = useGetWellData(url)

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields(data.state)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state])

  function backAction() {
    navigate(backUrl)
  }

  return (
    <>
      <RecordContent>
        <ButtonsContainer containerStyle='left'>
          <Button
            onClick={backAction}
            label='Back'
            iconAlignment='left'
            icon='arrow-left'
            buttonStyle='text-action'
            isSkeleton={isLoading}
          />
        </ButtonsContainer>
        <Heading level={2}>Aquifer test</Heading>
        <AquiferTestDetailsViewForm fields={fields} isLoading={isLoading} />
        <Divider />
        <TestAnalysisViewForm fields={fields} isLoading={isLoading} wellId={id} />
        <Divider />
        <AquiferTestQualityRatingFormEdit fields={fields} isLoading={isLoading} />
        <Divider />
        <AquiferTestResultsViewForm fields={fields} isLoading={isLoading} />
        {fields.aquiferTestObservationWells?.map((obsWell: Partial<AquiferTestObservationWellFieldsView>, index) => (
          <>
            <Divider />
            <AquiferTestObservationWellsViewForm
              key={obsWell.id}
              index={index}
              fields={obsWell}
              isLoading={isLoading}
            />
          </>
        ))}{' '}
      </RecordContent>
      <RecordFooter
        notes={
          Array.isArray(fields.notes) &&
          !!fields.notes.length && <NotesWrapperView notes={fields.notes} isLoading={isLoading} />
        }
        areActionsFixed
      >
        <WellViewButtons wellId={id} />
      </RecordFooter>
    </>
  )
}
